import React, { useEffect, useState } from "react";
import { getLoggedInUser } from "../../utils/helper";

import Inhouse from "./Inhouse";
import Outsourced from "./Outsourced";
import Loader from "../../utils/Loader";

export default function HomeLanding() {
    const TOKEN = localStorage.getItem("kloka:token:data");
    const [profile, setProfile] = useState("");
    const [sums, setSums] = useState("");
    const [tasks, setTasks] = useState("");
    const [notifs, setNotifs] = useState("");
    
    useEffect(() => {
        if(TOKEN){
            getLoggedInUser(TOKEN).then((res) => { 
                if(res.data.success){   
                    setProfile(res.data.data);  
                    setSums(res.data.sums);  
                    setTasks(res.data.task);  
                    setNotifs(res.data.notifs); 
                }
            }).catch((err) => { 
                console.log(err.response) 
            });
        }
    }, [TOKEN]);

    return (
        <>
            {profile ? (
                <>
                    {(profile.type === "inhouse") && (
                        <Inhouse 
                        user={profile ? profile : null} 
                        sums={sums ? sums : null}  
                        tasks={tasks ? tasks : null}  
                        notifs={notifs ? notifs : null}  
                        /> 
                    )}
                    
                    {(profile.type === "outsourced") && (
                        <Outsourced 
                        user={profile ? profile : null} 
                        sums={sums ? sums : null}  
                        tasks={tasks ? tasks : null}  
                        // notifs={notifs ? notifs : null}  
                        /> 
                    )}
                </> 
            ) : <Loader /> }

        </>
    );
}
